import React from 'react';
import { QuestionSchemeEditorContainer } from 'src/components/questionSchemeEditor/container/questionSchemeUIEditor.component';

export const QuestionSchemeBuilder = () => {
  return <QuestionSchemeEditorContainer />;
};
